import { useState } from 'react'
import { Input } from '../ui'
import { hexToHsv, hsvToHex, isValidHex } from '../tag-color-utils'
import { HueSlider } from './hue-slider'
import { SaturationValuePad } from './saturation-value-pad'

interface Props {
  value: string
  onChange(hex: string): void
}

export const CustomColorPanel: React.FC<Props> = ({ value, onChange }) => {
  const { h, s, v } = hexToHsv(value)
  const [hexInput, setHexInput] = useState(value)

  function commitHex(next: string) {
    setHexInput(next)
    if (isValidHex(next)) onChange(next.toLowerCase())
  }

  return (
    <div className="flex flex-col gap-2 p-2 w-64">
      <SaturationValuePad
        hue={h}
        s={s}
        v={v}
        onChange={(ns, nv) => onChange(hsvToHex(h, ns, nv))}
      />
      <HueSlider hue={h} onChange={nh => onChange(hsvToHex(nh, s, v))} />
      <div className="flex items-center gap-2">
        <span className="text-xs text-gray-500">HEX</span>
        <Input
          value={hexInput.startsWith('#') ? hexInput : `#${hexInput}`}
          maxLength={9}
          onChange={next => commitHex(next)}
          onBlur={() => setHexInput(value)}
        />
      </div>
    </div>
  )
}
